import { FIGURES } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

export const Figures = () => (
  <section className="border-y border-white/10 bg-[#1D1327] py-24 lg:py-32" data-testid="section-chiffres-cles">
    <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
      <Reveal>
        <Eyebrow>Chiffres clés</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-3xl font-serif text-4xl leading-[1.08] text-cream sm:text-5xl">
          Des résultats réels, publiés avec transparence.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 lg:grid-cols-5">
        {FIGURES.filter((f) => f.value !== null).map((figure, i) => (
          <Reveal key={figure.label} delay={i * 0.05}>
            <div data-testid={`figure-${i}`} className="border-l border-neon/40 pl-5">
              {typeof figure.value === "number" ? (
                <p className="font-serif text-5xl text-cream lg:text-6xl">{figure.value}</p>
              ) : (
                <p className="pt-1 font-serif text-2xl italic leading-snug text-neon-light lg:text-3xl">{figure.value}</p>
              )}
              <p className="mt-4 font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-white/50">
                {figure.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-14 max-w-2xl text-sm leading-relaxed text-white/40">
          Ces chiffres sont issus de nos propres projets et de ceux de nos clients, présentés publiquement lors de nos
          webinaires. Chaque indicateur supplémentaire sera publié uniquement lorsqu'il sera réel et vérifiable.
        </p>
      </Reveal>
    </div>
  </section>
);
